/**
 * 状态管理模式
 */
import Vue from "vue"
import Vuex from "vuex"
//
import actions from "./actions"
import mutations from "./mutations"
import state from "./state"
//
Vue.use(Vuex)
//
const store = new Vuex.Store({
  	state,//状态
	actions,//异步触发状态变更
	mutations,//同步触发状态变更
})
//
export default store



// WEBPACK FOOTER //
// ./src/store/zhongheng/index.js